var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VContainer',{staticClass:"page__auth__sign-in"},[_c('AuthSignIn',{attrs:{"auth-service":_vm.authService}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }